import React, { Fragment } from "react"; 
import { Seo, Breadcrumb, ScrollTopBtn } from "../components";
import { HeaderThree, ServiceSingle, FooterTwo } from "../containers";

const serviceContent = {
  topImage: "/images/service/sr-d-1-1-mad.jpg",
  heading: "Mobile & App Development",
  description: `Our Mobile & App Development services deliver custom, high-performance applications for iOS, Android, and cross-platform environments. 
  We design intuitive and engaging mobile experiences that help businesses reach users effectively, improve engagement, and drive growth. 
  From concept and UI/UX design to deployment and post-launch support, we ensure apps are scalable, secure, and optimized for performance.`,

  middleImage: "/images/service/sr-d-1-2-mad.jpg",
  features: [
    "Native iOS & Android App Development",
    "Cross-Platform Solutions (React Native, Flutter)",
    "Custom UI/UX Design for Mobile Experiences",
    "API Integration & Backend Connectivity",
    "App Performance Optimization & Maintenance"
  ],

  challengeHeading: "Challenges in Mobile App Development",
  challengeParagraphs: [
    `Developing mobile applications involves handling multiple device types, OS versions, screen sizes, and performance considerations. 
    Security, seamless connectivity, and smooth user experiences are critical for app adoption.`,
    `Our team addresses these challenges through modular design, rigorous testing, and using modern frameworks to build apps that are reliable, secure, and deliver superior user engagement.`
  ],

  bottomImages: [
    "/images/service/sr-d-1-3.jpg",
    "/images/service/sr-d-1-4.jpg"
  ]
};

const MobileAppDevelopment = () => (
  <Fragment>
    <Seo
      title="Mobile & App Development | Tech Ayukta"
      description="Tech Ayukta provides Mobile & App Development services for iOS, Android, and cross-platform applications with optimized performance and user-friendly design."
      keywords="Mobile App Development, iOS Apps, Android Apps, Cross-Platform Apps, React Native, Flutter, Tech Ayukta"
      canonical="https://www.techayukta.com/services/mobile-app-development"
    />
    <HeaderThree />
    <Breadcrumb
      pageName="Mobile & App Development"
      bgImage="/images/breadcumb/breadcumb-bg.jpg"
    />
    <ServiceSingle
      className="space-top space-extra-bottom"
      serviceContent={serviceContent}
    />
    <FooterTwo />
    <ScrollTopBtn />
  </Fragment>
);

export default MobileAppDevelopment;
